module.exports = __webpack_public_path__ + "static/media/Icon2.3a30af12.png";